/** Integrity comparison for saved vs recomputed custom prices (spec §2.3).
 *  Both sides are Record<sku, dollars> rounded to cents, but they are built in
 *  different key orders — applyOverrides walks the basis compositions, the
 *  saved record comes back in DynamoDB/GraphQL order — so an order-sensitive
 *  JSON.stringify comparison never matches once more than one SKU is priced.
 *  Compare as an unordered map of integer cents: order-independent, and immune
 *  to the sub-cent float drift a dollars round-trip can leave behind. */
export function customPricesMatch(
  a: Record<string, number>, b: Record<string, number>,
): boolean {
  const aKeys = Object.keys(a);
  if (aKeys.length !== Object.keys(b).length) return false;
  return aKeys.every((sku) => {
    const av = a[sku];
    const bv = b[sku];          // undefined when the SKU is absent from b
    return av !== undefined && bv !== undefined
      && Math.round(av * 100) === Math.round(bv * 100);
  });
}
